import React from 'react';

interface DecisionTreeExpandedContextProps {
  expanded: string | undefined;
  setExpanded: (value: string | undefined) => void;
}

export const DecisionTreeExpandedContext = React.createContext<DecisionTreeExpandedContextProps | undefined>(undefined);

export default function useDecisionTreeExpandedContext() {
  const context = React.useContext(DecisionTreeExpandedContext);
  if (context === undefined) {
    throw new Error('useDecisionTreeExpandedContext must be used within a DecisionTreeExpandedContextProvider');
  }
  return context;
}
